import { buildModelManager } from "../builder.js";
const DefaultShopifyStoreCreditAccountSelection = {
  __typename: true,
  id: true,
  balance: true,
  createdAt: true,
  ownerId: true,
  shopId: true,
  updatedAt: true
};
const modelApiIdentifier = "shopifyStoreCreditAccount";
const pluralModelApiIdentifier = "shopifyStoreCreditAccounts";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyStoreCreditAccountSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyStoreCreditAccount does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyStoreCreditAccountManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyStoreCreditAccountSelection,
  operations
);
export {
  DefaultShopifyStoreCreditAccountSelection,
  ShopifyStoreCreditAccountManager
};
//# sourceMappingURL=ShopifyStoreCreditAccount.js.map
